import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { athletePropTypes } from '../../hooks/UseAppContext';
import constants from '../../constants';
import classNames from 'classnames/bind';

import styles from './AthleteSticker.module.scss';

function AthleteSticker({ athlete, handleEvaluation, opinion }) {
  const cx = classNames.bind(styles);
  const [evalPublic] = useState();
  const [labelUs, labelYou] = constants.athletes.evalStrings;
  const opinions = [
    {
      value: athlete.eval,
      emoji: constants.eval[athlete.eval].emoji,
      title: constants.eval[athlete.eval].title,
      label: labelUs,
    },
    {
      value: opinion,
      emoji: constants.eval[opinion ? opinion : 'question'].emoji,
      title: opinion ? constants.eval[opinion].title : 'dê seu voto',
      label: labelYou,
    },
    // {
    //   value: evalPublic,
    //   emoji: constants.eval[evalPublic ? evalPublic : 'question'].emoji,
    //   title: evalPublic ? constants.eval[evalPublic].title : 'carregando',
    //   label: labelThem,
    // },
  ];

  const handleClick = (value) => () => {
    handleEvaluation(athlete.id, value);
  };

  return (
    <li>
      <div className={styles.wrapper}>
        <figure className={cx(['figure', `level${athlete.eval}`])}>
          <div className={styles.cartolaInfo}>
            <span className={styles.cartolaIcon}>
              <img src="https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/public/2022/3/X7bmBjjtbUiGuzLMfUx2.svg" />
            </span>
            <span className={styles.cartolaShaddow}>
              <img src="https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/public/2022/3/Ie91FNB2cIfU85OkY1Xc.svg" />
            </span>
            <span className={styles.cartolaBackground}>
              <img src="https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/public/2022/3/7m5wYQkRx3IaejWf6Die.svg" />
            </span>
            <span className={styles.cartolaValue}> C${athlete.cartola}</span>
          </div>
          <img
            className={styles.image}
            src={athlete.picture.big}
            title={athlete.name}
            alt={athlete.name}
          />
          <figcaption className={styles.caption}>
            <div className={styles.grade}>
              {constants.eval[athlete.eval].title}
            </div>
            <div className={styles.name}>{athlete.name}</div>
            <div className={styles.position}>
              {athlete.position.description}
            </div>
          </figcaption>
        </figure>
        <div className={styles.opinion}>
          {opinions.map((item, index) => (
            <figure
              className={styles.eval}
              key={`opinion__key__${index}__${Math.random()}`}
            >
              <abbr className={styles.emoji} title={item.title}>
                {item.emoji}
              </abbr>
              <figcaption
                className={cx({
                  who: true,
                  ge: item.label === labelUs,
                })}
              >
                {item.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
      <figure className={styles.action}>
        <figcaption className={styles.actionCaption}>
          {opinion ? constants.eval[opinion].title : 'dê seu voto'}
        </figcaption>
        <div className={styles.vote}>
          {constants.evalOrder.map((value, index) => (
            <button
              className={cx([
                {
                  radio: true,
                  radioActive: opinion ? value === opinion : true,
                },
                `level${value}`,
              ])}
              key={`AthleteSticker__radio__${value}__${Math.random()}`}
              type="radio"
              id={`${athlete.id}__eval${value}`}
              name="filter-brazil"
              value={value}
              checked={value === opinion}
              onClick={handleClick(value)}
            >
              <abbr className={styles.abbr} title={constants.eval[value].title}>
                {constants.eval[value].emoji}
              </abbr>
            </button>
          ))}
        </div>
      </figure>
    </li>
  );
}

AthleteSticker.propTypes = {
  ...athletePropTypes,
  opinion: PropTypes.number.isRequired,
  handleEvaluation: PropTypes.func.isRequired,
};

AthleteSticker.defaultProps = {
  id: 0,
  teamId: 0,
  name: '',
  position: {
    role: '',
    description: '',
    field: '',
  },
  picture: {
    big: '',
    small: '',
  },
  opinion: 0,
  handleEvaluation: () => {},
};

export default AthleteSticker;
